import React from "react";
import GestionUnites from "./GestionUnites";

// One responsive workspace keeps forms, details and permission checks shared.
export default function ResponsiveUnits(props) {
  return <GestionUnites {...props} />;
}
